import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import FadeIn from "../compliance/FadeIn";

// Import framework to manage datepicker
import dayjs from "dayjs";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";

// Import MUI elements
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import { Grid, Paper, ToggleButton, ToggleButtonGroup } from "@mui/material";
import { styled } from "@mui/material/styles";

// Import Icons
import BarChartIcon from "@mui/icons-material/BarChart";
import PeopleIcon from "@mui/icons-material/People";
import RestartAltIcon from "@mui/icons-material/RestartAlt";
import SendIcon from "@mui/icons-material/Send";

const Item = styled(Paper)(({ theme }) => ({
  padding: 10,
}));

const DashboardHeader = ({
  handleReset,
  handleEndDateChange,
  endDate,
  setSelectedOption,
  selectedOption,
  onButtonClick,
  openModal,
}: any) => {
  let navigate = useNavigate();
  const [layout, setLayout] = React.useState<string | null>("analysis");

  const handleLayout = (
    event: React.MouseEvent<HTMLElement>,
    newLayout: string | null
  ) => {
    if (newLayout !== null) {
      setLayout(newLayout);
    }
  };
  return (
    <FadeIn transitionDuration={700}>
      <Item className='ops-navbar-filters'>
        <Box sx={{ flexGrow: 1 }}>
          <Grid container spacing={2}>
            <Grid item xs={6} sm={6} md={3} lg={1.5} xl={1.5}>
              <FormControl fullWidth>
                <InputLabel id='select-label'>Reference Period</InputLabel>
                <Select
                  labelId='select-label'
                  id='select'
                  value={selectedOption}
                  onChange={(e) => {
                    setSelectedOption(e.target.value);
                    handleEndDateChange(e.target.value, endDate);
                  }}
                >
                  <MenuItem value='Last 7 days'>Last 7 days</MenuItem>
                  <MenuItem value='Last 30 days'>Last 30 days</MenuItem>
                  <MenuItem value='Last 60 days'>Last 60 days</MenuItem>
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={6} sm={6} md={3} lg={1.5} xl={1.5}>
              <LocalizationProvider
                dateAdapter={AdapterDayjs}
                adapterLocale='en'
              >
                <div>
                  <DatePicker
                    defaultValue={dayjs("2024-01-31")}
                    label='Report Date'
                    value={endDate}
                    onChange={(e) => {
                      handleEndDateChange(
                        selectedOption,
                        e || dayjs("2024-01-31")
                      );
                    }}
                  />
                </div>
              </LocalizationProvider>
            </Grid>
            <Grid item xs={12} sm={12} md={5} lg={2.8} xl={2.8}>
              <div className='exec-buttons'>
                <Button
                  className='ops-nav-btn exec-nav-btn'
                  variant='contained'
                  endIcon={<RestartAltIcon />}
                  onClick={handleReset}
                >
                  Reset Filters
                </Button>
                <Button
                  className='ops-nav-btn exec-nav-btn'
                  variant='contained'
                  endIcon={<SendIcon />}
                  onClick={() => {
                    onButtonClick();
                    openModal();
                  }}
                >
                  Send Report
                </Button>
              </div>
            </Grid>
            <Grid
              className='switch-toggle'
              item
              xs={12}
              sm={12}
              md={6.2}
              lg={6.2}
              xl={6.2}
            >
              <ToggleButtonGroup
                value={layout}
                exclusive
                onChange={handleLayout}
                aria-label='layout toggle button group'
                className='layout-toggle'
              >
                <ToggleButton
                  onClick={() => navigate("/complaints")}
                  value='overview'
                  aria-label='overview layout'
                >
                  <PeopleIcon />
                  <span>Executive</span>
                </ToggleButton>
                <ToggleButton
                  onClick={() =>
                    navigate("/complaints/detailed?callReason=fees")
                  }
                  value='analysis'
                  aria-label='analysis layout'
                >
                  <BarChartIcon />
                  <span>Analysis</span>
                </ToggleButton>
              </ToggleButtonGroup>
            </Grid>
          </Grid>
        </Box>
      </Item>
    </FadeIn>
  );
};

export default DashboardHeader;
